import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BarChartIcon from "@mui/icons-material/BarChart";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import WavesIcon from "@mui/icons-material/Waves";

import {
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  Typography,
} from "@mui/material";

import { lazy, Suspense, useEffect, useState } from "react";
import ModalWindow from "./modal/ModalWindow";
import Pausaly from "./Pausaly";
import SrazkovaVoda from "./SrazkovaVoda";
import Vodomery from "./Vodomery";

export default function DetailOdbernehoMista({
  selectedCollectionPoint,
  handleBack,
  showOdberatelNazev,
  onRefreshData,
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(
    selectedCollectionPoint.vodomery.length > 0
      ? "vodomery"
      : selectedCollectionPoint.pausaly.length > 0
        ? "pausaly"
        : "srazkovaVoda"
  );
  const [allMeters, setAllMeters] = useState([]);
  const GraphInvoices = lazy(() => import("./GraphInvoices"));
  const GraphSurface = lazy(() => import("./GraphSurface"));

  const [view, setView] = useState("invoices"); // "invoices" | "surface"
  useEffect(() => {
    setAllMeters(selectedCollectionPoint?.vodomery);
  }, [selectedCollectionPoint?.vodomery]);

  function handleShowGraph() {
    setModalVisible(true);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        maxHeight: "calc(100vh - 64px)", // 64px je například výška vašeho headeru+footeru
        overflowY: "auto",
      }}
    >
      <Box sx={{ flex: "1 1 auto" }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Detail místa: {selectedCollectionPoint.cisloOm}
        </Typography>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Číslo obce: {selectedCollectionPoint.cisloObce}
        </Typography>
        {showOdberatelNazev && selectedCollectionPoint.odberatelNazev != null && (
          <Typography variant="body1" sx={{ mb: 1 }}>
            Odběratel: {selectedCollectionPoint.odberatelNazev}
          </Typography>
        )}
        <Typography variant="body1" sx={{ mb: 2 }}>
          Adresa: {selectedCollectionPoint.ulice},{" "}
          {selectedCollectionPoint.obec}
        </Typography>

        <Typography variant="subtitle1" sx={{ mb: 2 }} color="info">
          {selectedCollectionPoint.periodaOdectu === "M"
            ? "Měsíční odečty"
            : "Roční odečty"}
        </Typography>

        <ButtonGroup
          variant="contained"
          sx={{ mb: 2, width: { xs: "100%", sm: "inherit" } }}
        >
          <Button
            onClick={() => setActiveTab("vodomery")}
            startIcon={
              <WaterDropIcon
                color={activeTab === "vodomery" ? "white" : "primary"}
              />
            }
            color={activeTab === "vodomery" ? "primary" : "white"}
          >
            Vodoměry
          </Button>
          <Button
            onClick={() => setActiveTab("pausaly")}
            startIcon={
              <AssessmentIcon
                color={activeTab === "pausaly" ? "white" : "primary"}
              />
            }
            color={activeTab === "pausaly" ? "primary" : "white"}
          >
            Paušály
          </Button>
          <Button
            onClick={() => setActiveTab("srazkovaVoda")}
            startIcon={
              <WavesIcon
                color={activeTab === "srazkovaVoda" ? "white" : "primary"}
              />
            }
            color={activeTab === "srazkovaVoda" ? "primary" : "white"}
          >
            Srážková voda
          </Button>
        </ButtonGroup>

        {/* Vodoměry */}
        {activeTab === "vodomery" && (
          <Vodomery
            vodomery={allMeters}
            setAllMeters={setAllMeters}
            today={selectedCollectionPoint.dnes}
            zobrazitVyberTypu={selectedCollectionPoint.zobrazitVyberTypu}
            showOdberatelNazev={showOdberatelNazev}
            onRefreshData={onRefreshData}
          />
        )}

        {/* Paušály */}
        {activeTab === "pausaly" && (
          <Pausaly selectedCollectionPoint={selectedCollectionPoint} />
        )}

        {/* Srážková voda */}
        {activeTab === "srazkovaVoda" && (
          <SrazkovaVoda selectedCollectionPoint={selectedCollectionPoint} />
        )}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mt: 1 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "row",
            justifyItems: "start",
          }}
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
        >
          Zpět na seznam
        </Button>
        {selectedCollectionPoint && (
          <Button
            variant="contained"
            color="secondary"
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "row",
              justifyItems: "start",
            }}
            startIcon={<BarChartIcon />}
            onClick={handleShowGraph}
          >
            Zobrazit graf
          </Button>
        )}
      </Box>

      <ModalWindow visible={modalVisible} setVisible={setModalVisible}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: { xs: "80vw" },
          }}
        >
          <ButtonGroup variant="outlined">
            <Button
              variant={view === "invoices" ? "contained" : "outlined"}
              onClick={() => setView("invoices")}
            >
              Fakturace
            </Button>
            <Button
              variant={view === "surface" ? "contained" : "outlined"}
              onClick={() => setView("surface")}
            >
              Srážková voda
            </Button>
          </ButtonGroup>

          <Suspense fallback={<CircularProgress />}>
            {view === "invoices" ? (
              <GraphInvoices
                idOdberneMisto={selectedCollectionPoint.idpk}
                periodaOdectu={selectedCollectionPoint?.periodaOdectu}
              />
            ) : (
              <GraphSurface data={selectedCollectionPoint.srazkovaVoda} />
            )}
          </Suspense>
        </Box>
      </ModalWindow>
    </Box>
  );
}
